import * as yup from "yup";

export const modalAddContactSchema = yup.object().shape({
    name: yup.string().required('Du måste ange ett namn'),    
    phoneNumbers: yup.array().of(yup.string().min(6, 'För kort telefonnummer').required()).required('Du måste ange ett telefonnummer'),
    emailAddresses: yup.array().of(yup.string().email('Felaktigt format på mailadressen').required()).required('Du måste ange en mailadress'),
    customerNumber: yup.number().required(),
});